var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCutaway(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8454 18.1179C65.216 7.41076 19.3622 7.17796 14.9397 18.1179L19.3622 29.2904C25.4915 31.4628 37.7968 35.9008 37.983 36.2732C38.1692 36.6456 56.6815 32.7042 65.9143 30.687L66.8454 18.1179Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5179 50.9368L42.6384 31.8504C54.9631 26.3979 61.5087 23.3403 66.8456 17.8848L76.6215 36.2729C73.0369 43.9346 70.1548 46.7523 64.5179 50.9368Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7417 42.5575C43.3474 47.4025 37.0408 46.8361 25.8794 40.9282V37.4368L37.7502 31.385C40.7201 31.6417 42.349 31.8491 45.1985 32.3161L54.7417 42.5575Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0087 49.3074L39.3796 31.3848C28.6726 27.6606 22.962 24.4227 14.9398 18.1174C10.0968 24.368 7.77536 28.5175 4 36.5055C6.68753 43.524 8.91285 46.2855 14.0087 49.3074Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.7759,
    cy: 39.0664,
    r: 2.32761,
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6035 27.3003C37.69 25.4428 42.5926 25.2327 52.4141 27.3003",
    stroke: "#999999",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutaway);
export default __webpack_public_path__ + "static/media/cutaway.3adbc2a3df59647cc00c50eccbeb8b66.svg";
export { ForwardRef as ReactComponent };